import React from 'react'
import Stores from 'Stores'
import swal from 'sweetalert'
import { localisationMaster, translate as loc } from 'Localisation/Localisation'
import { superAxiosRequest } from 'axiosApi'
import styles from './GroupUserUnit.module.scss'
import { useHistory } from 'react-router-dom'

export default function GroupUserUnit(props) {
  const history = useHistory()
  let dataStorage = localStorage.getItem('ud')
  var data = JSON.parse(dataStorage)
  const id = data.user_data.profile.id
  const udId = data.user_data.id

  const wkday = (weekdays) => {
    let days = [
      localisationMaster('text_22', 'groups/all-groups'),
      localisationMaster('text_23', 'groups/all-groups'),
      localisationMaster('text_24', 'groups/all-groups'),
      localisationMaster('text_25', 'groups/all-groups'),
      localisationMaster('text_26', 'groups/all-groups'),
      localisationMaster('text_27', 'groups/all-groups'),
      localisationMaster('text_28', 'groups/all-groups'),
    ]
    let ready = []
    //let c;
    for (let i = 0; i < weekdays?.length; i++) {
      ready.push(days[weekdays[i] - 1])
    }
    let wkdays = ready.join('/')
    return wkdays
  }

  const rData = (text) => {
    const body = document.createElement('div')
    body.innerHTML += text
    body.style.lineHeight = '25px'
    return body
  }

  const getSafeValue = (value, fallback = '') => {
    return value !== null && value !== undefined ? value : fallback
  }

  const formatTime = (timeString) => {
    return timeString &&
      typeof timeString === 'string' &&
      timeString.length >= 5
      ? timeString.substring(0, 5)
      : ''
  }

  const formatSchedule = (schedule) => {
    if (!schedule) return ''

    const weekday = getSafeValue(schedule.weekdays)
      ? wkday(schedule.weekdays)
      : ''
    const startTime = formatTime(schedule.start_at)
    const finishTime = formatTime(schedule.finish_at)

    if (!weekday || !startTime || !finishTime) return ''

    return `${weekday} с ${startTime}, до ${finishTime}`
  }

  const text = `${localisationMaster('text_38', 'groups/all-groups')} <br /><strong>${getSafeValue(props.items.company?.name)} ${getSafeValue(props.items.course_level?.name)} - ${getSafeValue(props.items.name)}</strong> <br />
    ${(() => {
      const schedule = props.items?.schedules?.[0] || props.items?.ws_schedules
      const formattedSchedule = formatSchedule(schedule)

      if (formattedSchedule) {
        return `${localisationMaster('text_39', 'groups/all-groups')}<br />
                <strong>${formattedSchedule}.</strong> <br />`
      }
      return ''
    })()}`

  const stesxt = `Вы успешно записались в группу!<br />
                Ваша группа:<br /><strong>${getSafeValue(props.items.number)} - ${getSafeValue(props.items.name)}</strong><br />   
                ${(() => {
                  const schedule = props.items?.schedules?.[0]
                  const weekday = getSafeValue(schedule?.weekdays)
                    ? wkday(schedule.weekdays)
                    : ''
                  const startTime = formatTime(schedule?.start_at)
                  const finishTime = formatTime(schedule?.finish_at)

                  if (weekday && startTime && finishTime) {
                    return `Время занятий:<br /><strong>${weekday}, ${startTime}-${finishTime}</strong><br />`
                  }
                  return ''
                })()}
                Необходимо произвести оплату за группу в течении 3-х дней. <br /> 
                Пополнить баланс можно на странице профиля.`

  const atext = `${getSafeValue(props.udata?.full_name, 'Клиент')} записан в группу!<br />
               Группа:<br /><strong>${getSafeValue(props.items.number)} - ${getSafeValue(props.items.name)}</strong><br />
               ${(() => {
                 const schedule = props.items?.schedules?.[0]
                 const weekday = getSafeValue(schedule?.weekdays)
                   ? wkday(schedule.weekdays)
                   : ''
                 const startTime = formatTime(schedule?.start_at)
                 const finishTime = formatTime(schedule?.finish_at)

                 if (weekday && startTime && finishTime) {
                   return `Время занятий:<br /><strong>${weekday}, ${startTime}-${finishTime}</strong><br />`
                 }
                 return ''
               })()}`

  const addToGroup = (idGroup, idClient) => {
    swal({
      title: localisationMaster(
        id !== props.id_user ? 'text_472' : 'text_47',
        'groups/all-groups',
      ),
      content: rData(text),
      //icon: "warning",
      buttons: [
        localisationMaster('button_2', 'alert'),
        localisationMaster('button_1', 'alert'),
      ],
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        let apiConf = {
          method: 'post',
          link: 'groups/add_client_to_group',
        }
        let body = {
          group_id: idGroup,
          client_id: idClient,
        }
        superAxiosRequest(apiConf, body)
          .then((res) => {
            swal({
              content: rData(id !== props.id_user ? atext : stesxt),
              buttons: [
                localisationMaster(
                  'button-close',
                  'online-schedule/record-customer',
                ),
                'Перейти в проофиль',
              ],
              icon: 'success',
            }).then((add) => {
              if (!add) return
              history.push(`/account_clients/${udId}`)
            })
            props.drop()
          })
          .catch((err) => {
            swal(err.response.data.error, {
              icon: 'error',
            })
          })
      } else {
        swal(localisationMaster('canceled', 'alert'))
      }
    })
  }

  const isNewSchedule = props.items.new_schedule
  const lastTeacher = (schedules, teachers) => {
    let teacher
    if (isNewSchedule) {
      teacher = props.items.ws_schedules.teachers?.[0]
    } else if (schedules?.length > 0) {
      if (teachers.length > 0) {
        const activeSch = schedules.find(
            (x) =>
              new Date(x.date_from) < new Date() &&
              new Date(x.date_until) > new Date(),
          ),
          futureSch = schedules.filter(
            (x) => new Date(x.date_from) > new Date(),
          ),
          pastSch = schedules.filter((x) => new Date(x.date_until) < new Date())
        teacher = activeSch
          ? teachers.find((x) => x.id === activeSch.teachers[0])
          : futureSch.length
            ? teachers.find((x) => x.id === futureSch[0].teachers[0])
            : pastSch.length &&
              teachers.find(
                (x) => x.id === pastSch[pastSch.length - 1].teachers[0],
              )
      }
    }
    return teacher
      ? Stores.transliterate(teacher.full_name)
      : localisationMaster('text_97', 'groups/all-groups')
  }

  const classroom = props.items.classroom ? (
    <>
      <div className={styles.groupCard__delimiter}></div>
      <span>{props.items.classroom}</span>
    </>
  ) : null

  return (
    <div
      className='user-group-listing-unit'
      style={props.items.registered ? { backgroundColor: '#d6eaea' } : null}
    >
      <div className='user-group-listing-unit-info'>
        <div className={styles.groupCard}>
          <div className={styles.groupCard__info}>
            <div className='user-group-listing-unit-info-header'>
              <span>{`${props.items.number} - ${props.items.name}`}</span>
            </div>

            <div className={styles.groupCard__infoBox}>
              <div className={styles.groupCard__infoBlock}>
                <span>
                  {props.items.skill_level !== null &&
                    props.items.skill_level.name}
                </span>
                <div className={styles.groupCard__delimiter}></div>
                <span>
                  {props.items.discipline !== null &&
                    props.items.discipline.name}
                </span>
                <div className={styles.groupCard__delimiter}></div>
                <span>
                  {lastTeacher(props?.items?.schedules, props?.items?.teachers)}
                </span>
              </div>

              <div className={styles.groupCard__infoBlock}>
                <div>
                  <span>{props.items.location.name}</span>
                </div>
                <div className={styles.groupCard__delimiter}></div>
                <span>
                  {props.items.online
                    ? localisationMaster('text_29', 'groups/all-groups')
                    : localisationMaster('text_29a', 'groups/all-groups')}
                </span>
                <div className={styles.groupCard__delimiter}></div>
                {classroom}
                <span>
                  {props.items.course_level !== null &&
                    props.items.course_level.name}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='user-group-listing-unit-button '>
        <button
          className={props.items.registered ? 'disabled' : null}
          onClick={
            !props.items.registered
              ? () => addToGroup(props.items.id, props.id_user, props.items)
              : null
          }
        >
          Записаться
        </button>
      </div>
    </div>
  )
}
